// extracted by mini-css-extract-plugin
module.exports = {"gradient":"styles_gradient__lZMJe","full":"styles_full__3uwLP","bottom":"styles_bottom__3j14h","cover":"styles_cover__1ZImU"};